import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { People } from '@lyearn/icons';
import { EventStatusEnum } from '@/types/schema';

import InformationBox from '../InformationBox';
import { RegisteredClassInfoProps } from './types';

const RegisteredClassInfo: React.FC<RegisteredClassInfoProps> = ({
  className,
  usersCount,
  isUserRegistered,
  isRegistrationRequired,
  status,
  color,
}) => {
  const { isMobile } = useScreen();
  const { t } = useTranslation('Events');

  if (
    (!isUserRegistered && !usersCount) ||
    !isRegistrationRequired ||
    status === EventStatusEnum.Completed ||
    status === EventStatusEnum.Archived
  ) {
    return null;
  }

  if (isUserRegistered && usersCount! < 1) {
    return (
      <InformationBox
        Icon={People}
        className={className}
        content={t('Events:SingleRegistration')}
        variant={isMobile ? 'body-short-01' : 'body-short-02'}
      />
    );
  }

  if (isUserRegistered) {
    return (
      <InformationBox
        Icon={People}
        className={className}
        content={t('Events:RegisteredClassInfo', { usersCount })}
        variant={isMobile ? 'body-short-01' : 'body-short-02'}
      />
    );
  }

  return (
    <InformationBox
      Icon={People}
      className={className}
      color={{
        icon: isMobile ? 'icon-secondary' : undefined,
        text: color?.text,
      }}
      content={t('Events:Attendance', { usersCount })}
      variant={isMobile ? 'body-short-01' : 'body-short-02'}
    />
  );
};

export default RegisteredClassInfo;
